<div class="stateDate">
  <div *ngIf="isComponentPage" [formGroup]="stateForm" fxLayout="row" fxLayoutAlign="space-between end" class="statesDataSelectionRow">
    <div fxFlex="10" fxLayout="row" fxLayoutAlign="start">
      <mat-checkbox class="blinkingCheckBox" color="primary" formControlName="isBlink">
         {{ trans.Blink | translate }}
      </mat-checkbox>
    </div>

    <div fxFlex="10" fxLayout="column" fxLayoutAlign="center">
      <label for="pickColor" class="colorPickerIcon">
        <img src="../../../../assets/images/color-picker.png" alt="color picker"/>
      </label>
      <input
        [style.background]="color"
        [style.color]="color"
        id="pickColor"
        class="colorPickerIput"
        [cpPresetColors]="[
          '#fff',
          '#dddd',
          '#2889e9',
          '#e920e9',
          '#fff500',
          'rgb(236,64,64)'
        ]"
        [cpCancelButton]="true"
        [cpCancelButtonClass]="'btn btn-primary btn-xs'"
        [cpOKButton]="true"
        [cpSaveClickOutside]="false"
        [cpOKButtonClass]="'btn btn-primary btn-xs'"
        [(colorPicker)]="color"
      />
    </div>

    <mat-form-field appearance="outline" fxFlex="28" class="m-b-0">
      <mat-label>   {{ trans.State | translate }}
      </mat-label>
      <input
        type="text"
        matInput
        pattern="^[a-zA-Z]([a-zA-Z0-9_-])+$"
        formControlName="state"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="22" class="m-b-0">
      <mat-label> {{ trans.Value | translate }}</mat-label>
      <input type="number"
        class="stateValue"
        matInput
        formControlName="value"
      />
    </mat-form-field>

    <div fxFlex="18" fxLayout="row" fxLayoutAlign="end">
      <button type="button" mat-raised-button color="primary"
              [disabled]="stateForm.invalid || isInvalidState" (click)="addState()">
         {{ trans.Add | translate }}
      </button>
    </div>
  </div>

  <span class="warning-message" *ngIf="isInvalidState"> Name or Value Already Exists! </span>

  <div
    fxLayout="row"
    class="stateDataRow"
    fxLayoutAlign="space-between center"
    *ngFor="let state of states; let i = index"
  >
    <div fxFlex="2" class="m-0">
      <mat-checkbox [disabled]="!isComponentPage"
      [ngModelOptions]="{standalone: true}" color="primary"
      [(ngModel)]="state.isBlink"></mat-checkbox>
    </div>
    <div fxFlex="5" class="m-0">
      <!--<span class="pickedColor"></span>-->
      <input [disabled]="!isComponentPage"
        [style.background]="state.color"
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="state.color"
        class="colorPickerIput"
        [cpPresetColors]="[
          '#fff',
          '#dddd',
          '#2889e9',
          '#e920e9',
          '#fff500',
          'rgb(236,64,64)'
        ]"
        [cpCancelButton]="true"
        [cpCancelButtonClass]="'btn btn-primary btn-xs'"
        [cpOKButton]="true"
        [cpSaveClickOutside]="false"
        [cpOKButtonClass]="'btn btn-primary btn-xs'"
        [(colorPicker)]="state.color"
      />
    </div>

    <p fxFlex="25" class="m-0">
      {{ state.state }}
    </p>

    <p fxFlex="25" class="m-0 m-l-40" fxLayoutAlign="end">
      {{ state.value }}
    </p>

    <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">
      <button *ngIf="isComponentPage"
        mat-raised-button
        class="delbtn"
        color="primary"
        (click)="removeState(i)">
        <span class="iotech-icon-delete"></span>
      </button>
    </div>
  </div>
</div>